import React from 'react';
import { Error } from './';
import { ErrorMessage } from 'formik';

export const FormRow = ({ label, errorName, ...props }) => (
  <>
    <div className="flex w-full py-2 leading-10">
      <div className="mr-4 mt-[10px] w-[200px] text-right leading-normal">
        <label className="text-[0.9rem] uppercase [&_svg]:text-[1.5rem] [&_svg]:text-[var(--festy-sky-blue)]">
          {label}
        </label>
      </div>
      <div className="w-full [&_input]:w-full [&_select]:w-full [&_textarea]:w-full">
        {props.children}
        {errorName && <ErrorMessage name={errorName || ''} component={Error} />}
      </div>
    </div>
  </>
);
